import { render } from "./VestingInfoForm.vue?vue&type=template&id=932927aa&scoped=true"
import script from "./VestingInfoForm.vue?vue&type=script&lang=js"
export * from "./VestingInfoForm.vue?vue&type=script&lang=js"

import "./VestingInfoForm.vue?vue&type=style&index=0&id=932927aa&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-932927aa"]])

export default __exports__